<template>
    <div>
        <!-- <h2>{{pageLoader}}</h2> -->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>   
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class=" modal-popup " v-if="confirm == '1'">
            <div class="row w-100 justify-content-center align-items-center">
                <div class=" mb-3 middleBox">
                    <div class="whiteBG px-4 py-5">
                        <div class="d-flex align-items-center justify-content-center">
                            <div class="text-center ConfirmedPopup">
                                <feather type="info"></feather>
                                <h2 class="mb-3">{{$t('toolVps_sureImp')}}</h2>
                                <div class="d-flex justify-content-center align-items-center">
                                    <a href="#" class="common_btn btn_xs mr-2" @click.prevent="confirm = '2' ; vpsOper(getDataType, server_id)">{{$t('toolVps_confirm')}}</a>
                                    <a href="#" class="common_btn btn_xs darkBG" @click.prevent="confirm = ''">{{$t('toolVps_cancel')}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center no-gutters"  v-if="passwordTabShow"> 
            <div class=" middleBox">
                <div class="mainTitle text-center mt-4 mb-3">
                    <h3 class="uppercase mb-4"> {{$t('cp_changePassword')}}</h3>
                </div>
                <div class="position-relative changeVpsPass">
                    <div class="customPp">
                        <button type="button" class="close d-flex align-items-center justify-content-center" data-dismiss="modal" aria-label="Close" @click.prevent="passwordTabShow = false; new_password = '' ; confirm_password = ''">
                            <feather type="x"></feather>
                        </button>
                    </div>
                    <div class="CustomBlockWidth inMiddle-area whitebox p-4 position-relative">
                        <div class="justify-content-center">
                            <div class="form-group field-wrapper dob">
                                <input placeholder=" " :type="inputtype1" v-model="new_password"   class="float-field form-control"  v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{12,24}$/}"   :class="{ 'is-invalid': submitted && errors.has('new_password') }"    ref="new_passwordInput" name="new_password" />
                                <label for="password" class="float-label"> {{$t('lg_password')}}</label>
                                <feather :type="iconType1" class="toggle-password" @click.prevent="switchVisibility('1')"></feather>
                                <p class="error" v-for="error in errors.collect('new_password')">
                                    <span v-show="error == 'The new_password field is required.'">{{$t('reg_passwordFieldReq')}}</span>
                                    <span v-show="error == 'The new_password field format is invalid.'">{{$t('reg_passCharVal')}}</span>
                                </p>
                            </div> 
                            <div class="form-group field-wrapper dob">
                                <input placeholder=" " :type="inputtype2" v-model="confirm_password"  class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{12,24}$/, confirmed:new_password}"  :class="{ 'is-invalid': submitted && errors.has('confirm_password') }" ref="confirm_passwordInput" name="confirm_password"  />
                                <label for="password" class="float-label"> {{$t('reg_conPassword')}}</label>
                                <feather :type="iconType2" class="toggle-password" @click.prevent="switchVisibility('2')"></feather>
                                <p class="error" v-for="error in errors.collect('confirm_password')">
                                    <span v-show="error == 'The confirm_password field is required.'">{{$t('reg_passwordFieldReq')}}</span>
                                    <span v-show="error == 'The confirm_password field format is invalid.'">{{$t('toolVps_passWordMustContain12')}}</span>
                                    <span v-show="error == 'The confirm_password confirmation does not match.'">{{$t('reg_newConfFieldSame')}}</span>
                                </p>
                            </div>
                            <div class="submitButton d-flex justify-content-center align-items-center w-100 mt-2 text-center">
                                <a href="#" class="prism_btn btn_sm" title="Change-Password" @click.prevent="confirm = '1'; vpsOper('3', server_id)"> {{$t('cp_changePassword')}}</a>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
        <div class=" supportpagetab "  v-if="Object.keys(vpsList).length > 0 && vpsList.vps.totalRecords > 0 && !show_create && !passwordTabShow">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="mb-0" v-html="$t('toolVps_vpsList')"></h2>
                <a class="common_btn btn_xs" href="#" @click.prevent="show_create = true">{{$t('toolVps_createVps')}}</a>
            </div>
            <div class=" mb-4 subscriptionList"><!-- mapIco-list-table -->
                <div class="tablePmm " ><!-- table-responsive -->
                    <table class="table pmmTable" >
                        <thead>
                            <tr>
                                <!-- <th>{{$t('ServerId')}} </th> -->
                                <th>{{$t('toolVps_Plan')}}</th>
                                <th>{{$t('subtrans_amount')}}</th>
                                <th>{{$t('vpsdetail_Created')}}</th>
                                <th>{{$t('vpsdetail_IPAddress')}}</th>
                                <th>{{$t('toolVps_Status')}}</th>
                                <th>{{$t('toolVps_type')}}</th>
                                <th>{{$t('vpsdetail_State')}}</th>
                                <th>{{$t('vpsdetail_action')}}</th>                                   
                            </tr>
                        </thead>
                        <tbody v-if="vpsList.vps.totalRecords > 0">
                            <tr v-for="(list,index) in vpsList.vps.records">
                                <!-- <td v-html="(list.server_id != '' && list.server_id != null)? list.server_id : '-'"></td> -->
                                <td v-html="(list.name != '' && list.name != null)? list.name : '-'"></td>
                                <td v-html="(list.amount != '' && list.amount != null)? list.amount : '-'"></td>
                                <td >{{list.created | moment(" DD MMMM YYYY")}}</td> 
                                <td v-html="(list.main_ip_address != '' && list.main_ip_address != null)? list.main_ip_address : '-'"></td>
                                <td ><span class="badge badge-pill" :class="(list.detailed_state == 'active')?'badge-success' : 'badge-warning'">{{list.detailed_state}}</span></td>
                                <td><p v-html="((parseInt(list.pay_type) == 0) ? 'paid' : ((parseInt(list.pay_type) == 2) ? 'loyalty points' : 'free'))"></p></td> 
                                <td >
                                    <div class="d-flex align-items-center">
                                        <span class="badge badge-pill badge-success stateStatus online mr-2"> <feather type="check"></feather></span> {{list.state}}</div>
                                </td>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <!-- <a href="#" class="readload_server" @click.prevent="loadOnce()"><feather type="refresh-cw"></feather></a> -->
                                        <div class="position-relative">
                                            <span class="tableoption dotAreaForButton" @click.prevent="detailDiv(index,'buttons')"><feather type="more-horizontal" size="1rem"></feather></span>                                
                                            <div class="tablefilter box-shadow p-0"   :id="'buttons'+index" v-if="parseInt(showButtonDetailInfo) == index">
                                                 <ul>
                                                    <li class="d-flex"  @click.prevent="vpsOper('1', list.server_id) ; confirm = '1'; showButtonDetailInfo = ''">
                                                        <a href="#" class="d-inline-flex align-items-center" title="Shut-Down"  ><feather class="powerico" type="power" size="1em"></feather> <span>{{$t('toolVps_Shut_Down')}}</span></a>
                                                    </li>
                                                    <li class="d-flex" @click.prevent="vpsOper('0', list.server_id) ; confirm = '1'; showButtonDetailInfo = ''">
                                                        <a href="#" class="d-inline-flex align-items-center" title="Restart"  > <feather class="rebootico" type="refresh-ccw" size="1em"></feather> <span>{{$t('toolVps_Restart')}}</span></a>
                                                    </li>
                                                    <li  class="d-flex" @click.prevent="vpsOper('2', list.server_id) ; confirm = '1'; showButtonDetailInfo = ''">
                                                        <a href="#" class="d-inline-flex align-items-center" title="Reboot"  ><feather class="rebootico"  type="refresh-ccw" size="1em"></feather> <span>{{$t('toolVps_Reboot')}}</span></a>
                                                    </li>
                                                    <li  class="d-flex" >
                                                        <a href="#" class="d-inline-flex align-items-center"  title="Change-Password" @click.prevent="passwordTabShow = true ; server_id =  list.server_id ; confirm = ''; showButtonDetailInfo = ''"> <feather class=" passwordico" type="lock" size="1em"></feather> <span>{{$t('toolVps_Change_Pass')}}</span></a> 
                                                    </li>
                                                 </ul>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </td>
                            </tr>
                        </tbody>
                        <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="'8'" :list="vpsList.vps" v-else></loader-component>
                    </table> 
                </div>
            </div>
            <div class="mapIco-list-table mb-4 ">
                <h2 class="mb-3">{{$t('toolVps_SubList')}}</h2>
                <div class="tablePmm table-responsive" >
                    <table class="table pmmTable" >
                        <thead>
                            <tr>
                                <!-- <th>{{$t('Plan')}}</th> -->
                                <th>{{$t('toolVps_accWalt')}}</th>
                                <!-- <th>{{$t('toolVps_Price')}}</th> -->
                                <th>{{$t('toolVps_type')}}</th>
                                <th>{{$t('toolVps_strtDate')}}</th>
                                <th>{{$t('toolVps_endDate')}}</th> 
                                <th>{{$t('toolVps_nextpayment')}}</th>
                                <th>{{$t('toolVps_Priodicity')}}</th> 
                                <th>{{$t('toolVps_Action')}}</th>                                   
                            </tr>
                        </thead>
                        <tbody v-if="vpsList.subscriptions.totalRecords > 0">
                            <tr v-for="(list,index) in vpsList.subscriptions.records" > 
                                <!-- <td >{{list.pdetail_name}}</td> -->
                                <td><p v-if="list.wallet_no != '' && list.wallet_no != null && list.wallet_no != undefined">{{list.wallet_no}}</p><p v-else>{{list.account || '-'}}</p></td>
                                <!-- <td >{{list.plan_price}}</td> -->
                                <td >{{list.plan_type || '-'}}</td>
                                <td >{{list.subscripton_start_date | moment(" DD MMMM YYYY")}}</td> 
                                <td >{{list.subscripton_end_date | moment(" DD MMMM YYYY")}}</td> 
                                <td >{{list.next_payment_date | moment(" DD MMMM YYYY")}}</td> 
                                <td >{{list.perodicity || '-'}}</td>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <!-- <a href="#" class="readload_server" @click.prevent="loadOnce()"><feather type="refresh-cw"></feather></a> -->
                                        <div class="position-relative">
                                            <span class="tableoption dotAreaForButton" @click.prevent="detailDiv1(index,'buttons')"><feather type="more-horizontal" size="1rem"></feather></span>                                
                                            <div class="tablefilter box-shadow p-0"   :id="'buttons'+index" v-if="parseInt(showButtonDetailInfo1) == index">
                                                 <ul>
                                                    <li class="d-flex"><!--   @click.prevent="vpsOper('1', list.server_id) ; confirm = '1'; showButtonDetailInfo1 = ''" -->
                                                        <router-link class="d-inline-flex align-items-center" :to="{name: 'fxView.subsTransactionDetail' , query: { 'id': list.id}}"  title="View" data-placement="top"  data-toggle="tooltip">
                                                            {{$t('toolVps_VieDet')}}
                                                        </router-link>
                                                    </li>
                                                    <li class="d-flex"><!--  @click.prevent="vpsOper('0', list.server_id) ; confirm = '1'; showButtonDetailInfo1 = ''" -->
                                                         <router-link :to="{name: 'fxView.sub_change_account' , query: { 'id': list.id}}"  title="View" data-placement="top"  data-toggle="tooltip" class="d-inline-flex align-items-center">
                                                            {{$t('toolVps_UpdAcc')}}
                                                        </router-link>
                                                    </li>
                                                    <li  class="d-flex"><!--  @click.prevent="vpsOper('2', list.server_id) ; confirm = '1'; showButtonDetailInfo1 = ''" -->
                                                        <router-link :to="{name: 'fxView.unsubscribe_plan' , query: { 'id': list.id, 'account' :  list.pdetail_name}}"  title="View" data-placement="top"  data-toggle="tooltip" class="d-inline-flex align-items-center">
                                                            {{$t('toolVps_cancel')}}
                                                        </router-link>
                                                    </li>
                                                 </ul>
                                            </div>
                                        </div>
                                    </div>
                                   
                                    
                                    
                                </td>
                            </tr>
                        </tbody>
                        <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="'6'" :list="vpsList.subscriptions" v-else></loader-component>
                        
                    </table> 
                    <pagination :getList="vpsList.subscriptions" :limit="pageLimit" v-if="vpsList.subscriptions.totalRecords > 15"></pagination>
                </div>
            </div> 
        </div>
        <div class="text-center p-5 customLoader" v-else-if="!vpsList.hasOwnProperty('vps') || pageLoader" > 
            <h4>{{$t('dw_acc_fund_plzWaitWhileProc')}}</h4>
        </div> 
        <div  v-if="(Object.keys(vpsList).length > 0 && vpsList.vps.totalRecords == 0 && !passwordTabShow) || (show_create && !passwordTabShow)">
            
            <div v-if="vpsList.vps.totalRecords == 0">
                <section class="blockElement blockTwo overflow-hidden p-0">
                    <div class="row justify-content-center justify-content-center">
                        <div class="col-12 text-center col-md-9">
                            <div class="main-title flipInX wow">
                                <h2 class="mb-3" v-html="$t('toolVps_vps')"></h2> 
                                <p>{{$t('toolVps_vpsTilte')}}</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="blockElement hrTed p-0 pb-0">
                    <div class="row justify-content-center p-width mt-4">
                        <div class="col-12 col-lg-3 col-md-6 text-center wow flipInX">
                            <div class="card border-0 customHover p-3 customHorizontal align-items-center">
                                <div class="card-imgt"><img class="card-img-custom" src="../../../../../static/fxView/images/reduced_latency.svg" alt="Reduced Latency"></div>
                                <div class="card-body py-2 pl-3 pr-2 text-left">
                                    <h4 class="card-title mb-1">{{$t('toolVps_redLate')}}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-3 col-md-6 text-center wow flipInX">
                            <div class="card border-0 customHover p-3 customHorizontal align-items-center">
                                <div class="card-imgt"><img class="card-img-custom" src="../../../../../static/fxView/images/FREEdeposit.svg" alt="FREE deposit"></div>
                                <div class="card-body py-2 pl-3 pr-2 text-left">
                                    <h4 class="card-title mb-1">{{$t('toolVps_freeOn5000')}}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-3 col-md-6 text-center wow flipInX">
                            <div class="card border-0 customHover p-3 customHorizontal align-items-center">
                                <div class="card-imgt"><img class="card-img-custom" src="../../../../../static/fxView/images/remote_access.svg" alt="Remote Access"></div>
                                <div class="card-body py-2 pl-3 pr-2 text-left">
                                    <h4 class="card-title mb-1">{{$t('toolVps_remoteAccess')}}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-3 col-md-6 text-center wow flipInX">
                            <div class="card border-0 customHover p-3 customHorizontal align-items-center">
                                <div class="card-imgt"><img class="card-img-custom" src="../../../../../static/fxView/images/stable_environment.svg" alt="Stable Environment"></div>
                                <div class="card-body py-2 pl-3 pr-2 text-left">
                                    <h4 class="card-title mb-1">{{$t('toolVpsstab_Env')}}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

           <!--Section-->
            <section class="blockElement blockfive overflow-hidden px-0">
                <no-trading-account :demo_live_both="''" :totalRecords = "'0'" v-if="parseInt(get_user.verified_status) == 0"></no-trading-account>
                <div class="row mt-4" v-else>
                    <subscription-service-plan></subscription-service-plan>
                    <div class="row no-gutters w-100 justify-content-center">
                        <div class="col-12 col-md-10 mt-3 d-flex justify-content-between align-items-center">
                            <a class="d-flex" href="#" @click.prevent="show_create = false" v-if="vpsList.vps.totalRecords > 0"> <feather type="chevron-left"></feather>{{$t('toolVps_back_vpsList')}}</a>
                            <small><a href="../../../../../static/fxView/pdf/Fxview_VPS_T&C.pdf" target="_blank" class="green">{{$t('toolVps_tc')}}</a></small>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    import subscription_service_plan from '../../tradingtools/subscription_service_plan'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'VPS',
        data() {
            return {
				vps : 'silver',
                show_create : false,
                showButtonDetailInfo : '',

                showButtonDetailInfo1 : '',

                //===========prop in loader component=======
                col_span : 5,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
                pageLimit : '15',
                search : '',
                page : '1',

                passwordTabShow : false,
                submitted : false,
                new_password : '',
                confirm_password : '',
                inputtype1 : 'password',
                inputtype2 : 'password',
                iconType1 : 'eye-off',
                iconType2 : 'eye-off',
                showpassword1 : false,
                showpassword2 : false,
                server_id : '',
                getDataType : '',
                confirm : ''
            }
        },
        components:{
            subscriptionServicePlan : subscription_service_plan
        },
        methods:{
            detailDiv(index,getData) {
                if(getData == 'div'){
                    var element = document.getElementById(getData+index)
                    if ($(element).hasClass('hide')){
                        $(element).removeClass('hide');
                    }else{
                        $(element).addClass('hide');
                    } 
                }else{
                    if(parseInt(this.showButtonDetailInfo) == index){
                        this.showButtonDetailInfo = ''
                    }else{
                        this.showButtonDetailInfo = index
                    }
                }
            },

            detailDiv1(index,getData) {
                if(getData == 'div'){
                    var element = document.getElementById(getData+index)
                    if ($(element).hasClass('hide')){
                        $(element).removeClass('hide');
                    }else{
                        $(element).addClass('hide');
                    } 
                }else{
                    if(parseInt(this.showButtonDetailInfo1) == index){
                        this.showButtonDetailInfo1 = ''
                    }else{
                        this.showButtonDetailInfo1 = index
                    }
                }
            },
            loadOnce:function(){
                location.reload();
            },
            reset(){
                this.passwordTabShow = false
                this.submitted = false
                this.new_password = ''
                this.confirm_password = ''
                this.server_id = ''
            },
            switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }else if(getData == '2'){
                    this.showpassword2 = !this.showpassword2
                    if(this.showpassword2){
                        this.inputtype2 = 'text'
                        this.iconType2 = 'eye'
                    }else{
                        this.inputtype2 = 'password'
                        this.iconType2 = 'eye-off'
                    } 
                }
            },
            vpsOper(getData, server_id){
                if(this.confirm == '2'){
                    let input_json={
                        'globalParams' :{
                            'server_id' : this.server_id
                        },
                        'localParams' :{ "parameter" : this}
                    }
                    if(this.getDataType == '0'){
                        this._runVpsRestart(input_json)
                    }else if(this.getDataType == '1'){
                        this._runVpsShutdown(input_json)
                    }else if(this.getDataType == '2'){
                        this._runVpsReboot(input_json)
                    }else if(this.getDataType == '3'){
                        const _that = this
                        _that.submitted = true;
                        _that.$validator.validate().then(valid => {
                            if (valid) {
                                input_json.globalParams.password  = _that.new_password
                                _that._runVpsChangePassword(input_json)
                            }else{
                                _that.handleValidationErrorAdvanced(_that.errors)
                            }
                        });
                    }
                }else{
                    this.server_id = server_id
                    this.getDataType = getData
                }
            },
            listing(){
                this.server_id = ''
                this.getDataType = ''
                this.confirm = ''
                this.passwordTabShow = false
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                    } ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetVpsList(inputJson)
            }
        },
        created(){
            if(this.$store.getters[Const.GET_VPS_LIST] != ''){
                this.loaderFuncRun = '0'
            }
            this.listing()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/tools/pages/vps.vue